import ChatInputField from "../ChatInputField";
import styles from "./chat-box.module.css";
import MessageBox from "../MessageBox";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { globalInteractions, interactions } from "../../constants/interactions";
import { textSplitter } from "../../helpers/textSplitter";
import usePeriodicRender from "../../hooks/usePeriodicRender";

const preWrap = (message) => {
  return message.includes('schreibe HALLO HUANG') || message.includes('write HELLO HUANG')
};

const langFromDoc = () => {
  const dataLang = document
    .getElementById("game-bot-3")
    .getAttribute("data-language");
  return dataLang === "de" ? "de" : "en";
};

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

const ChatBox = ({ show }) => {
  const size = useWindowSize();
  const [messages, setMessages, isRendering, renderPeriodicaly] =
    usePeriodicRender();
  const listContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const isMounted = useRef(false);
  const currentInteraction = useRef("Schritt1 Start");
  const lang = useRef(langFromDoc()).current;

  const changeInteraction = (interaction) => {
    currentInteraction.current = interaction?.trim();
  };

  const scrollToBottom = () => {
    if (
      listContainerRef.current &&
      listContainerRef.current.scrollHeight >
        listContainerRef.current.clientHeight
    ) {
      messagesEndRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  };

  const onSubmit = (message, isInteraction = false) => {
    if (Object.keys(globalInteractions).some((key) => key === message)) {
      const tempMessages = [...messages];
      tempMessages.push({ isUser: true, message });
      setMessages(tempMessages);
      renderPeriodicaly(interactions[globalInteractions[message]][lang]);
      changeInteraction(globalInteractions[message]);
      return;
    }

    if (message?.toUpperCase() === "RESTART") {
      const tempMessages = [...messages];
      tempMessages.push({ isUser: true, message });
      setMessages(tempMessages);
      renderPeriodicaly(interactions[`Schritt1 Start`][lang]);
      changeInteraction("Schritt1 Start");
      return;
    }

    if (isInteraction) {
      currentInteraction.current = message;
      renderPeriodicaly(
        interactions[currentInteraction.current][lang],
        currentInteraction.current
      );
      changeInteraction(currentInteraction.current);
    } else {
      const tempMessages = [...messages];
      tempMessages.push({ isUser: true, message });
      setMessages(tempMessages);

      const interaction = interactions.hasOwnProperty(
        currentInteraction.current
      )
        ? interactions[currentInteraction.current].interaction(message)
        : null;
      if (interaction) {
        interactions.hasOwnProperty(interaction) &&
          renderPeriodicaly(interactions[interaction][lang], interaction);
        changeInteraction(interaction);
      }
    }
  };

  useEffect(scrollToBottom, [messages]);

  useEffect(() => {
    if (show && !isMounted.current) {
      interactions.hasOwnProperty(`Schritt1 Start`) &&
        renderPeriodicaly(interactions[`Schritt1 Start`][lang]);
      isMounted.current = true;
    }
  }, [show]);

  return (
    <div className={styles.container} id="main-box">
      <div className={styles.listContainer} ref={listContainerRef}>
        {messages.map((message, index) => {
          const hasLink = message?.message.includes(
            "You can book other exciting reality escape games via"
          );
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: message?.isUser ? "flex-end" : "flex-start",
              }}
            >
              <div
                style={{
                  background: message?.isUser ? "#9076F6" : "#F1F1F0",
                }}
                className={styles.messageContainer}
              >
                <MessageBox
                  style={{
                    color: message?.isUser ? "white" : "black",
                    whiteSpace: preWrap(message?.message)
                      ? "pre-wrap"
                      : null,
                  }}
                  size={size}
                  onSubmit={onSubmit}
                  hasLink={hasLink}
                  text={
                    message?.isUser || hasLink
                      ? message?.message
                      : textSplitter(message?.message)
                  }
                />
              </div>
            </div>
          );
        })}
        {isRendering && <p className={styles.typing}>Typing...</p>}
        <div ref={messagesEndRef} />
      </div>
      <ChatInputField
        disabled={isRendering}
        disableInput={
          interactions[currentInteraction.current].disableInput || false
        }
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default ChatBox;
